import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import { validate } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import services from '../service';
import MenuItem from '@material-ui/core/MenuItem';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import Joi, { func } from '@hapi/joi'
import FormHelperText from '@material-ui/core/FormHelperText';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'VIEWVEHICLEREGISTRATION'
export function VehicleRegistrationListing(props) {
    const [vehicleRegistration, setVehicleRegistration] = useState([]);
    const [vehicleRegistrationsave, setvehicleRegistrationsave] = useState([]);
    const [vehicleRegistrationSearchData, setvehicleRegistrationSearchData] = useState({
        groupID: 0,
        operationEntityID: 0,

    });
    const [operationEntities, setOperationEntities] = useState([]);
    const [groups, setGroups] = useState();
    const [isTableHide, setIsTableHide] = useState(true);
    const contentRowNames = ["vehicleType", "vehicleRegistrationNumber", "capacity"]
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const schema = Joi.object().options({ allowUnknown: true });
    const screenData = "wiewvehicleRegistrationScreen";
    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [vehicleRegistrationSearchData.groupID]);

    useEffect(() => {
        trackPromise(
            handleSearch()
        )
    }, [vehicleRegistrationSearchData.operationEntityID]);

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    async function getPermissions() {

        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWVEHICLEREGISTRATION');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITVEHICLEREGISTRATION');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setvehicleRegistrationSearchData({
            ...vehicleRegistrationSearchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getAllGroups();
    }

    async function GetAllVehicleRegistration() {
        let model = {
            groupID: parseInt(vehicleRegistrationSearchData.groupID),
            operationEntityID: parseInt(vehicleRegistrationSearchData.operationEntityID),

        }
        const response = await services.GetAllVehicleRegistration(model)
        setVehicleRegistration(response);


        if (response.length > 0) {

            setvehicleRegistrationsave(response)
        }
    }
    function getVehicleTypeName(vehicleTypeID) {
        switch (vehicleTypeID) {
            case 1:
                return "Car";
            case 2:
                return "Van";
            case 3:
                return "Three Wheel";
            case 4:
                return "Lorry";
            default:
                return "";
        }
    }

    async function getOperationEntities() {
        const operationEntity = await services.GetAllOperationEntityByGroupID(vehicleRegistrationSearchData.groupID);
        setOperationEntities(operationEntity);
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result);
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }
    function handleVehicleCardClick(vehicleRegistration) {
        let model = {
            groupID: vehicleRegistrationSearchData.groupID,
            operationEntityID: vehicleRegistrationSearchData.operationEntityID,
            vehicleTypeID: vehicleRegistration.vehicleTypeID,
            vehicleRegistrationNumber: vehicleRegistration.vehicleRegistrationNumber,
            fuelTypeID: vehicleRegistration.fuelTypeID,
            capacity: vehicleRegistration.capacity,
            vehicleID: vehicleRegistration.vehicleID,

        }
        props.history.push({
            pathname: 'vehicleRegistration/vehicleCardAddEdit/',
            data: model,
            edit: true,
            screen: screenData
        }
        );

    }
    function generateDropDownMenu(data) {

        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    async function handleSearch(e) {

        if (e !== undefined) {
            const errorMessages = validate(vehicleRegistrationSearchData);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.GetAllVehicleRegistration(vehicleRegistrationSearchData);
        var resGrouped = groupByID(response);
        let keys = Object.keys(resGrouped);
        let arrayCollection = [];
        setIsTableHide(false);
        destroyDataTable();
        setVehicleRegistration(arrayCollection);
        createDataTable();
    }

    function handleChange(e) {
        const target = e.target
        const value = (target.name === 'isActive' || target.name === 'isErpEnabled') ? target.checked : target.value


        setvehicleRegistrationSearchData({
            ...vehicleRegistrationSearchData,
            [e.target.name]: value
        })

    }
    function groupByID(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['vehicleRegistration']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }
    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setvehicleRegistrationSearchData({
            ...vehicleRegistrationSearchData,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,

        });
        destroyDataTable();
        setVehicleRegistration([]);
        setIsTableHide(true);
    }
    function onCancelClick() {
        setErrors({});
        clearState();
    }
    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (
                <td key={index}>{da[row] + " "}</td>
            )
        )
    });

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Vehicle Registration"
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    buttonText="Add vehicleRegistration details"
                                    path="vehicleRegistration/vehicleCardAddEdit" />
                            </div>
                            <hr />
                            <form>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={vehicleRegistrationSearchData.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={vehicleRegistrationSearchData.operationEntityID}
                                            onChange={(e) => handleChange(e)}>

                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(operationEntities)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={GetAllVehicleRegistration}
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            <div className="table-responsive row-top-gap" >
                                <table className="display dataTable no-footer" hidden={isTableHide}>
                                    <thead>
                                        {vehicleRegistration.length > 0 ?
                                            <tr>
                                                <th>Vehicle Type</th>
                                                <th>Registration No</th>
                                                <th>Capacity</th>
                                                <th>Actions</th>
                                            </tr> : null}
                                    </thead>
                                    <tbody>
                                        {vehicleRegistration.map((data, i) => {
                                            return (<tr key={i}>
                                                <td>{getVehicleTypeName(data.vehicleTypeID)}</td>
                                                <td>{data.vehicleRegistrationNumber}</td>
                                                <td>{data.capacity}</td>
                                                <td onClick={() => handleVehicleCardClick(data)}
                                                    style={{ cursor: "pointer" }}><i class="far fa-edit"></i>
                                                </td>
                                            </tr>);
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment >
    )
}